import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import Switch from "react-switch"
import PreviewTemplateModal from "./PreviewModal";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardDeck,
  CardFooter,
  CardHeader,
  CardImg,
  CardImgOverlay,
  CardText,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap"
import "react-toastify/dist/ReactToastify.css";
import axios from "axios"
import { getAllTemplateByType } from "../../store/templates/actions";
import TemplateSidebar from "components/VerticalLayout/TemplateSidebar";
import Swal from "sweetalert2";
import { API_URL } from "helpers/app_url";
import RsLink from "components/buttons/rsLink";
class ReferalTemp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tempTypes:[],
      template:''
    }
    this.handleTemplateClicks = this.handleTemplateClicks.bind(this)
    this.toggle = this.toggle.bind(this);
  }
 
 fetchMasterTemplate() {
    const { campType } = this.props.match.params;
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const params = {
          typeId: campType,
          agentId: localStorage.getItem('userId')
      }
      axios
        .get(`${API_URL}ProjectEmailTemplate/alltemplatesbytype`, { headers, params })
        .then((response) => {
          this.setState({ masterTemplates: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
  
componentDidMount() {
  this.fetchMasterTemplate();
}

componentDidUpdate(prevProps, prevState, snapshot) {
 
   const prevId = prevProps.match.params.campType;
    const currentId = this.props.match.params.campType;
    if (prevId !== currentId) {
        this.fetchMasterTemplate();
      
    }
}

toggle() {
  this.setState(prevState => ({
    modal: !prevState.modal,
  }));
}
getTemplateTypeName(id){
  if(id==1)
    return 'Pre-Construction Project';
  
}
handleTemplateClicks = () => {
  this.setState({ template: "", isEdit: false });
  this.toggle();
};
 deleteTemplate = (templateId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                const authUser = localStorage.getItem("authUser");
                if (!authUser) return;
    
                const obj = JSON.parse(authUser);
                const token = obj?.resultData?.bearerToken;
                if (!token) return;
    
                const str = 'Bearer ' + token;
    
                axios.delete(`https://rscoreapi.azurewebsites.net/api/ProjectEmailTemplate/${templateId}`, {
                    headers: { Authorization: str }
                })
                .then(() => {
                    this.setState(prevState => ({
                        masterTemplates: prevState.masterTemplates.filter(template => template.id !== templateId)
                    }));
                    
                    // Show success message
                    Swal.fire("Deleted!", "The template has been deleted.", "success");
                })
                .catch(err => {
                    console.error("Error deleting template:", err);
                    Swal.fire("Error!", "Failed to delete the template.", "error");
                });
            }
        });
    }

handleTemplateClicks = arg => {
  const template = arg;
  this.setState(prevState => ({
    viewmodal: !prevState.viewmodal,
  }));
  this.setState({
    template: {
      id: template.id,
      uiTemplateId: template.uiTemplateId,
      agentId: template.agentId,
      templateTitle: template.templateTitle,
      templateContent: template.templateContent,
      templateType: template.templateType,
      publishStatusId: template.publishStatusId,
      templateDescription: template.templateDescription,
      templateCSS: template.templateCSS,
      templateJS:template.templateJS,
      isActive:template.isActive
    },
    isEdit: true,
  });
  //
  this.toggle();
};
render() {
 
  const { masterTemplates } = this.state;
  const template = this.state.template;
    return (
      <React.Fragment>
       
         <PreviewTemplateModal
          isOpen={this.state.viewmodal}
          toggle={this.handleTemplateClicks}
          data={template}
        />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>All Templates | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
           
          <Row>
              <Col  sm='3' className="pe-0">
              <TemplateSidebar />

          
            </Col>
            <Col sm="9">
            <Row className="project-header">
            <Col xl="6">
             <Breadcrumbs
              title={this.props.t("Templates")}
              breadcrumbItem={this.props.t("All Templates")}
            />
           
            </Col>
            <Col sm="6">
             <div className="mt-2 pt-2" style={{marginRight:30}}>
                                  <RsLink to={`/editor-email/${this.props.match.params.campType}`} className="btn btn btn-light btn-md float-end" iconClass="bx bx-plus">Add New Template</RsLink>
            
                                </div>
           
            </Col>
            </Row>
            <Row>

              
              <Col lg="12">
             
             

  
             
              <Row>
                <div className="col-lg-2">
                 
              </div>
              </Row>
             
             <Row>
          
            {map(masterTemplates, (template, templatekey) => (
            <Col lg={4} key={templatekey}>
              <Card className={"tempData tempData" + template.templateType }>
             
                <CardBody>
                  <CardTitle className="mt-0">{template.templateTitle}</CardTitle>
                  <CardText>{template.templateDescription}</CardText>
                </CardBody>
                <CardFooter>
                <a href="#" onClick={() => this.handleTemplateClicks(template)}  className="previewClass card-link float-left tempLink">View</a>
                 <Link to="#" onClick={() => this.deleteTemplate(template.id)} className="previewClass card-link float-end tempLink">Delete</Link>
                </CardFooter>
              </Card>
            </Col>
             ))}
           
             </Row>
 
 
 
  
             
             </Col>
             
             </Row>
             </Col>
             </Row>
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ReferalTemp.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
 
 
}
const mapStateToProps = ({Template}) => (
  {
   

  })
const mapDispatchToProps = dispatch => ({
  

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReferalTemp))
